// extracted by mini-css-extract-plugin
export default {"app":"App_app__oSpL2","background":"App_background__KpqQ6","logoBack":"App_logoBack__fKPpe"};